import { Card, CardBody, Col } from "reactstrap";

const InformasiCard = ({ shift }) => {
  // Ambil data dari staff pertama
  const firstStaff = shift.data[0];
  const { periode, lokasi } = firstStaff.shifts;

  return (
    <Col md="6">
      <Card className="h-100">
        <CardBody style={{ height: "350px" }}>
          <h5>Informasi</h5>
          <div className="mb-2">
            <strong>Periode:</strong>{" "}
            {new Date(periode).toLocaleDateString("id-ID", {
              year: "numeric",
              month: "long",
            })}
          </div>
          <div>
            <strong>Lokasi:</strong> {lokasi}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default InformasiCard;